import classNames from 'classnames';
import { Checkbox } from '@carbon/react';
import styles from './series-selector.module.scss';
import { capitalize } from 'lodash-es';

export interface SeriesItem {
  id: string;
  label: string;
  color?: string;
}

interface SeriesSelectorProps {
  allItems: string[];
  selectedItems: string[];
  onSelectionChange: (itemId: string) => void;
  className?: string;
  testId: string;
}

export const SeriesSelector = ({
  allItems,
  selectedItems,
  onSelectionChange,
  className,
  testId,
}: SeriesSelectorProps) => {
  return (
    <div
      className={classNames(styles.container, className)}
      data-testid={testId}
    >
      {allItems.map((item) => {
        const isSelected = selectedItems.includes(item);
        return (
          <Checkbox
            key={item}
            id={`${testId}-${item}-checkbox`}
            className={classNames(styles.checkbox, {
              [styles.unchecked]: !isSelected,
            })}
            labelText={
              <div className={styles.checkboxLabel}>
                <span className={styles.label}>
                  {['oil', 'gas', 'water'].includes(item)
                    ? capitalize(item)
                    : item}
                </span>
                <span
                  className={classNames(styles.icon, styles[`${item}Icon`])}
                />
              </div>
            }
            checked={isSelected}
            onChange={() => onSelectionChange(item)}
          />
        );
      })}
    </div>
  );
};
